import React, { Fragment, useState } from "react";
import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import { useTranslation } from "react-i18next";
import { CustomIcons } from "./CustomIcons";
import { TypeIcons } from "./TypeIcons";
import { store } from "../store";
import { useSnapshot } from "valtio";
import { useAuthHeader } from "../../../../../api/headersKeycloak";
import { useSyncDefaultSettingPeripheral } from "./hooks";

export function Peripheral() {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();

    const [filterActive, setLocalFilterActive] = useState<boolean>(false);
    const [dataIsUpdated, setDataIsUpdated] = useState<boolean | number>(false);
    const [data, setData] = useState<any>({});
    const { defaultSetting } = useSnapshot(store);

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 1,
            columnName: t("Peripherals"),

            customJsx: (e: any) => (
                <Fragment>{e.selectedRow["Péripheriques"]}</Fragment>
            ),
        },

        {
            indexOFColumn: 6,
            columnName: t("Type"),
            customJsx: (e: any) => <TypeIcons e={e} />,
            disableFilter: false,
        },
        {
            indexOFColumn: 7,
            columnName: t("Nombre d'applications"),
            customJsx: (e: any) => <CustomIcons e={e} />,
            disableFilter: false,
        },
    ];

    useSyncDefaultSettingPeripheral(data, defaultSetting);
    return (
        <div>
            <h2 className="mt-3 ml-3">{t("Peripherals")}</h2>
            <DynamicTable
                requestHeader={{
                    ...getAuthHeader,
                }}
                canMovedCheckboxLeftOnExpand
                url={"/DefaultSetting/peripheral.json"}
                setData={setData}
                canSelect
                customSelect
                canResize
                showGlobalFilter
                showFilter
                setLocalFilterActive={setLocalFilterActive}
                filterActive={filterActive}
                actionColumn={() => <></>}
                arrayOfCustomColumns={arrayOfCustomColumns}
                setDataIsUpdated={setDataIsUpdated}
                dataIsUpdated={dataIsUpdated}
                elevationTable={1}
                minHeight={"450px"}
                maxHeight={"450px"}
                name="tva"
            />
        </div>
    );
}
